module.exports = __webpack_public_path__ + "static/bala-c54fedba2e8a2b685576dc1e8b51ffb7.jpeg";